import {
  Box,
  Typography,
  TextField,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";
import { ListDivider } from "../../ui/ListStyles";
import { COLORS } from "../../ui/Theme";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import useSWR, { mutate } from "swr";
import { fetchData } from "../../lib/dashboard/data";
import { addTicketSchema } from "../../validation";
import { addTicket } from "../../lib/dashboard/actions";
import TextArea from "../../components/form/TextArea";
import { useState } from "react";
import { Link } from "react-router-dom";

const AddTicket = () => {
  const [appendix, setAppendix] = useState(null);
  const [isFileErr, setIsFileErr] = useState(false);

  const units = useSWR("/support/ticket/units", fetchData, {
    dedupingInterval: 60000,
  });

  const features = useSWR("/support/ticket/features", fetchData, {
    dedupingInterval: 60000,
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: zodResolver(addTicketSchema),
  });

  const handleChangeFile = (e) => {
    const file = e.target.files[0];
    if (!file) setAppendix(null);

    //validations
    const allowedTypes = ["application/zip", "image/jpeg", "image/png"];
    const maxSize = 10 * 1024 * 1024;

    if (allowedTypes.includes(file.type) && file.size < maxSize) {
      setAppendix(file);
      setIsFileErr(false);
    } else setIsFileErr(true);
  };

  const handleSendTicket = async (data) => {
    const formData = new FormData();

    const ticketData = {
      unit: data.unit,
      feature: data.feature,
      title: data.title,
      text: data.text,
    };

    formData.append("ticket", JSON.stringify(ticketData));
    formData.append("appendix", appendix);

    const res = await addTicket(formData, "/support/ticket");
    if (res.status === 200) {
      mutate("/support/ticket");
      reset();
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(handleSendTicket)}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography sx={{ fontSize: "20px" }}>تیکت جدید</Typography>
      <ListDivider flexItem />

      <FormControl fullWidth margin="normal">
        <Typography sx={{ fontSize: "14px", mb: 1 }}>عنوان تیکت</Typography>
        <TextField
          {...register("title")}
          error={!!errors.title}
          helperText={errors.title?.message}
        />
      </FormControl>

      <Box display="flex" gap={2} mb={2} width="100%">
        <FormControl fullWidth>
          <Typography sx={{ fontSize: "14px", mb: 1 }}>واحد</Typography>
          <Select
            defaultValue=""
            {...register("unit")}
            error={!!errors.unit}
            displayEmpty
          >
            {units.isLoading ? (
              <MenuItem disabled>در حال بارگذاری...</MenuItem>
            ) : (
              units.data.map((unit) => (
                <MenuItem key={unit.id} value={unit.id}>
                  {unit.name}
                </MenuItem>
              ))
            )}
          </Select>
          <Typography variant="caption" color="error">
            {errors.unit?.message}
          </Typography>
        </FormControl>

        <FormControl fullWidth>
          <Typography sx={{ fontSize: "14px", mb: 1 }}>ویژگی</Typography>
          <Select
            defaultValue=""
            {...register("feature")}
            error={!!errors.feature}
            displayEmpty
          >
            {features.isLoading ? (
              <MenuItem disabled>در حال بارگذاری...</MenuItem>
            ) : (
              features.data.map((feature) => (
                <MenuItem key={feature.id} value={feature.id}>
                  {feature.name}
                </MenuItem>
              ))
            )}
          </Select>
          <Typography variant="caption" color="error">
            {errors.feature?.message}
          </Typography>
        </FormControl>
      </Box>

      <FormControl fullWidth>
        <Typography sx={{ fontSize: "14px", mb: 1 }}>متن تیکت</Typography>

        <TextArea
          sx={{ height: "200px" }}
          {...register("text")}
          error={!!errors.text}
          helperText={errors.text?.message}
        />
        <Typography variant="caption" color="error">
          {errors.text?.message}
        </Typography>
      </FormControl>

      <Box>
        <Typography sx={{ fontSize: "14px", mb: 1 }}>فایل ضمیمه</Typography>
        <label className="btn" style={{ color: COLORS.BLUE }}>
          انتخاب فایل
          <input type="file" onChange={handleChangeFile} hidden />
        </label>

        <Typography
          sx={{
            fontSize: "12px",
            mt: 1,
            color: isFileErr ? "#d32f2f" : COLORS.GRAY,
          }}
        >
          فقط فرمت‌های jpg , png و zip مجاز هستند. سایز فایل نباید بیشتر از ۱۰
          مگابایت باشد.
        </Typography>
      </Box>

      <Box display="flex" gap={2} mt={3}>
        <button type="submit" className="btn btn-softblue">
          ارسال تیکت
        </button>
        <Link to="/dashboard" className="btn" style={{ width: "50%" }}>
          انصراف
        </Link>
      </Box>
    </Box>
  );
};

export default AddTicket;
